import React, { Component } from 'react';
import StreamingsForm from '../StreamingsForm/Container'
import Modal from '../Modal'
import { Uploader, UploadField } from '@navjobs/upload'
import {serverUrl} from '../../utils/restUtils'
import './pages.css'
import moment from 'moment'
import ReactTooltip from 'react-tooltip'
class Home extends Component {


    constructor(props){
	super(props)
	this.state = {modalVisible: null}
    }
    
    componentDidMount(){
	this.props.loadStreamings();
    }

    
    render() {
	const {streamings, removeStreaming, updateStreaming, loadStreamings} = this.props
	const {modalVisible} = this.state
	const toggleModal = (data) => {

	    let {modalVisible} = this.state
	    modalVisible = data
	    this.setState({modalVisible})
	}
	return (

	    <div>
		
		<h1>Administracija streamingov</h1>

		<button className="btn btn-brown btn-big full-width" onClick={() => toggleModal({})}><i className="fa fa-plus"></i> Dodaj streaming</button>

		<table className="table-striped pages">
		    <thead>
			<tr><th>Naslov</th><th>Zacetek</th><th>Konec</th><th>Idetifikacija</th></tr>
		    </thead>
		    <tbody>
			{
			    streamings &&
			    streamings.map(s =>
				<tr>
				    <td>{s.title}</td>
				    <td>{moment(s.date_from).format("D. MMMM YYYY ob HH.mm")}</td>
				    <td>{moment(s.date_to).format("D. MMMM YYYY ob HH.mm")}</td>
				    <td>{s.stream_id}</td>
				    <td>
					<button className="btn" data-tip="Spremeni" style={{float: 'left'}} onClick={() => toggleModal(s)}><i className="fa fa-edit"></i></button>
					<button className="btn"  data-tip="Zbriši" style={{float: 'right'}} onClick={() => removeStreaming(s)}><i className="fa fa-remove"></i></button>
				    </td>
				</tr>
			    )
			}
		    </tbody>
		</table>

		
		
		<Modal toggleModal={() => toggleModal(false)} visible={modalVisible}>
		    <h2>Dodaj streaming</h2>
		    <StreamingsForm successAction={toggleModal}  initialValues={modalVisible} />
		</Modal>
	    </div>
	);
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Streamings/index.jsx